import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBullhorn, FaDatabase, FaUsers } from 'react-icons/fa';
import Navbar from '../../../../ReusableBlocks/Navbar';
import * as PATH from '../../../../CentralisedLink';
import { useFeatureFlags } from '../../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../../FeatureFlags/featureFlagConstants';

const AdminHome = () => {
  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatureFlags();
  const enableAccountManagement = isFeatureEnabled(FEATURE_FLAGS.EnableAccountManagement);
  const enableTenantManagement = isFeatureEnabled(FEATURE_FLAGS.EnableTenantManagement);
  const enableAlertManagement = isFeatureEnabled(FEATURE_FLAGS.EnableAlertManagement);

  const handleUsersClick = () => {
    navigate(PATH.ADMIN_USERS_PATH);
  };

  const handleTenantsClick = () => {
    navigate(PATH.ADMIN_TENANTS_PATH);
  };

  const handleAlertsClick = () => {
    navigate(PATH.ADMIN_ALERTS_PATH);
  };

  return (
    <>
      <Navbar activeTab="ADMIN" />
      <main className="admin-home">
        <div className="container">
          <div className="admin-home__intro">
            <h1 className="admin-home__title">Admin Panel</h1>
            <p className="admin-home__subtitle">
              Manage Tech Central administrative modules
            </p>
          </div>

          <div className="admin-module-grid">
            {enableAccountManagement && (
              <button
                type="button"
                className="admin-module-card"
                onClick={handleUsersClick}
              >
                <div className="admin-module-card__icon-wrap">
                  <FaUsers className="admin-module-card__icon" />
                </div>
                <div className="admin-module-card__content">
                  <h2 className="admin-module-card__title">Accounts</h2>
                  <p className="admin-module-card__description">
                    Manage users, account requests, and access.
                  </p>
                </div>
              </button>
            )}

            {enableTenantManagement && (
              <button
                type="button"
                className="admin-module-card"
                onClick={handleTenantsClick}
              >
                <div className="admin-module-card__icon-wrap">
                  <FaDatabase className="admin-module-card__icon" />
                </div>
                <div className="admin-module-card__content">
                  <h2 className="admin-module-card__title">Tenants</h2>
                  <p className="admin-module-card__description">
                    Manage shared tenants, bookings, and onboarding.
                  </p>
                </div>
              </button>
            )}

            {enableAlertManagement && (
              <button
                type="button"
                className="admin-module-card"
                onClick={handleAlertsClick}
              >
                <div className="admin-module-card__icon-wrap">
                  <FaBullhorn className="admin-module-card__icon" />
                </div>
                <div className="admin-module-card__content">
                  <h2 className="admin-module-card__title">Alerts</h2>
                  <p className="admin-module-card__description">
                    Manage the global alert shown across Tech Central.
                  </p>
                </div>
              </button>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default AdminHome;
